import React from "react"
import { CoursesListPage } from "./presentation/CoursesListPage"
import { useCourseList } from "./useCourseList"

export const CoursesListContainer = () => {
  const courseList = useCourseList();
  return <CoursesListPage data={courseList} />
}